import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cx } from './utils';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  label: string;
  variant?: 'plain' | 'soft' | 'primary' | 'danger' | 'danger-hover';
  size?: 'sm' | 'md' | 'lg';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton({
  className,
  icon,
  label,
  variant = 'soft',
  size = 'md',
  title,
  ...props
}, ref) {
  return (
    <button
      ref={ref}
      className={cx('ui-icon-button', `ui-icon-button--${variant}`, `ui-icon-button--${size}`, className)}
      aria-label={label}
      title={title ?? label}
      {...props}
    >
      {icon}
    </button>
  );
});
